<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Edit Platform
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <form [formGroup]="platformForm">
        <table class="table editTable">
            <tr>
                <td class="w-2/4 px-3">
                    Platform Long Name
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="platformLongName">
                        <mat-error *ngIf="platformLongName.invalid">
                            Platform Long Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    Platform Short Name
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="platformShortName">
                        <mat-error *ngIf="platformShortName.invalid">
                            Platform Short Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    Remarks
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="remark">
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="platformForm.invalid"  (click)="updatePlatform()">Update</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>